import React from "react";
import { Link } from "react-router-dom";

import { ROUTES } from "~/router";
import AuthBanner, { BannerTypes } from "~/screens/Auth/components/AuthBanner";
import SignupForm from "~/screens/Auth/components/SignupForm";
import { AuthLayout } from "~/screens/Auth/Layout/AuthLayout";
import { Title, usePageTitle } from "~/shared";
import { Source } from "~/shared.types.ts";
import HighlightedText from "~/ui/common/HighlightedText";

interface SignupProps {
  source?: Source;
}

export const Signup = ({ source }: SignupProps) => {
  usePageTitle("Sign up");
  return (
    <AuthLayout
      banner={<AuthBanner type={BannerTypes.signup} />}
      showSupport
      showProtectedByRecaptcha
    >
      <section className="flex w-full items-center justify-center px-8 pb-8 xl:px-0 xl:pb-0">
        <div className="w-full max-w-lg bg-white py-2">
          <section className="space-y-6">
            <Title className="font-medium">
              Create your{" "}
              <HighlightedText>Elektra Health account</HighlightedText>
            </Title>
            <p className="text-indigo font-neue mb-3 text-lg font-medium">
              Access evidence-based menopause education, a private community,
              and 1:1 support.
            </p>

            <p className="text-sm font-normal text-neutral-800">
              (*) Mandatory field
            </p>
          </section>

          <SignupForm source={source} />

          <section>
            <p className="mt-4 text-gray-700">
              Already have an account?{" "}
              <Link
                to={ROUTES.fullLogin}
                className="text-indigo underline"
                role="link"
              >
                Log in
              </Link>
            </p>
          </section>
        </div>
      </section>
    </AuthLayout>
  );
};
